import React from 'react'

export default ({ color }) => (
    <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <g id="7-9" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
            <g id="RM---answer-autogen-question" transform="translate(-931.000000, -1081.000000)" stroke={ color ? color : '#FFFFFF' }>
                <g id="textbox---empty" transform="translate(261.000000, 1028.000000)">
                    <g id="Group-6" transform="translate(0.000000, 44.000000)">
                        <g id="close-icon" transform="translate(671.000000, 9.000000)">
                            <path d="M12.2277372,0 L0,13" id="Path"></path>
                            <path d="M0,0 L12.2277372,13" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
